import React, { useContext, useMemo } from 'react';

import { BundleContext } from '../../../../bundle-context';

import ItemsTable from '../../../../../../components/items-table/items-table';

import { createDeleteItemColumnDefinition, DeleteItemColumnId, deleteItemDataBuilder } from './columns/delete-item';

import { createEditProductNameColumnDefinition, EditProductNameColumnId, editProductNameDataBuilder } from './columns/product-name';

import {
  createEditProductQuantityColumnDefinition,
  EditProductQuantityColumnId,
  editProductQuantityDataBuilder,
} from './columns/product-quantity';
import { createEditProductSkuColumnDefinition, EditProductSkuColumnId, editProductSkuDataBuilder } from './columns/product-sku';

import bundleStyle from '../style.module.less';

export const BundleComponentsTable = () => {
  const { bundleComponents, editBundleComponent, removeBundleComponent } = useContext(BundleContext);

  const formattedItems = useMemo(
    () =>
      bundleComponents.map((item) => {
        return {
          id: item.id,
          [EditProductSkuColumnId]: editProductSkuDataBuilder(item),
          [EditProductNameColumnId]: editProductNameDataBuilder(item),
          [EditProductQuantityColumnId]: editProductQuantityDataBuilder(item),
          [DeleteItemColumnId]: deleteItemDataBuilder(item),
        };
      }),
    [bundleComponents],
  );

  const columns = useMemo(
    () => [
      createEditProductSkuColumnDefinition(),
      createEditProductNameColumnDefinition(),
      createEditProductQuantityColumnDefinition(),
      createDeleteItemColumnDefinition(),
    ],
    [],
  );

  return (
    <div className={bundleStyle.components}>
      <div className={bundleStyle['component-wrapper']}>
        <ItemsTable columns={columns} items={formattedItems} onColumnBlur={editBundleComponent} onRowDelete={removeBundleComponent} />
      </div>
    </div>
  );
};
